// Shared drafts for the TasksConfigModal and its extracted children
// (TagMultiPicker, TagSinglePicker, JoinConfigSection). Keeping these
// in one place avoids re-declaring the same shape across three files.

export type TagSetDraft = {
  tags: Record<string, string>;
  selectTag: string;
  selectTagValue: string;
};

export const PARENT_KIND_OPTIONS = ["task_rule", "bursts", "data", "results"] as const;
export type ParentKind = typeof PARENT_KIND_OPTIONS[number];

export const TAG_ACTION_OPTIONS = ["combine", "split", "match"] as const;
export type TagAction = typeof TAG_ACTION_OPTIONS[number];

export const TAG_ACTION_TITLES: Record<TagAction, string> = {
  combine:
    "Broadcast this parent across every value of the tag observed in the same origin; the parent's own value is ignored.",
  split: "Scope this parent on the tag using its own sensor's value; Split×Split forms a Cartesian product.",
  match: "Scope this parent on the tag AND require its value to equal the target parent's value in the same group.",
};

export type TagActionRowDraft = {
  tag: string;
  action: TagAction;
  pn: number | "";
};

export type ParentDraft = {
  id: number;
  kind: ParentKind;
  task_rule_id: number | null;
  tagSets: TagSetDraft[];
  tagActions: TagActionRowDraft[];
};

export type JoinConfigDraft = {
  filter_to_same: string[];
  timeout_minutes: number | null;
  min_success_fraction: number | null;
  share_grandparent: boolean;
  grandparent_timeout_minutes: number | null;
  retry_grace_minutes: number | null;
};
